import { render } from "./DispatchComplete.vue?vue&type=template&id=e49f2e96&scoped=true"
import script from "./DispatchComplete.vue?vue&type=script&lang=js"
export * from "./DispatchComplete.vue?vue&type=script&lang=js"

import "./DispatchComplete.vue?vue&type=style&index=0&id=e49f2e96&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e49f2e96"]])

export default __exports__